// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-view__desktop":"breakpoint-view_breakpoint-view__desktop__wpYUQ","breakpoint-view__mobile":"breakpoint-view_breakpoint-view__mobile___v27b"};